import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { Reveal } from '../../ui/Reveal/Reveal';
import { testimonials } from '../../../data/testimonials';
import './Testimonials.css';

export function Testimonials() {
  const [i, setI] = useState(0);
  const t = testimonials[i];
  const [metaParent] = useAutoAnimate<HTMLDivElement>({ duration: 500, easing: 'ease-in-out' });

  const next = () => setI((p) => (p + 1) % testimonials.length);
  const prev = () => setI((p) => (p - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="section testimonials">
      <div className="container">
        <Reveal>
          <span className="eyebrow">Spoken For</span>
        </Reveal>

        <div className="testimonials__stage">
          <span className="testimonials__quote-mark">"</span>

          <AnimatePresence mode="wait">
            <motion.blockquote
              key={t.id}
              className="testimonials__quote"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            >
              {t.quote}
            </motion.blockquote>
          </AnimatePresence>

          <div ref={metaParent} className="testimonials__meta">
            <div key={t.id} className="testimonials__meta-block">
              <div className="testimonials__author">{t.author}</div>
              <div className="testimonials__role">
                {t.role} · {t.company}
              </div>
            </div>
          </div>

          <div className="testimonials__controls">
            <button onClick={prev} aria-label="Previous" className="testimonials__btn" data-cursor="hover">
              <ChevronLeft size={20} strokeWidth={1.5} />
            </button>
            <div className="testimonials__counter">
              <span className="testimonials__counter-now">0{i + 1}</span>
              <span className="testimonials__counter-sep">/</span>
              <span>0{testimonials.length}</span>
            </div>
            <button onClick={next} aria-label="Next" className="testimonials__btn" data-cursor="hover">
              <ChevronRight size={20} strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
